// import Vue from "vue";
import Vuex from 'vuex';
import index from './modules/index';
import login from './modules/login';
import menu from './modules/menu';
export default new Vuex.Store({
    modules: {
        index,
        login,
        menu
    }
});